import * as React from "react";
const SvgMinus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 2, viewBox: "0 0 14 2", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 2V0H14V2H0Z", fill: "#8A9EB6" }));
export default SvgMinus;
